<template>

    <FloatingPanel title="Formulier" :width="400">

        <div class="canvas::canvas-blocks-modules-mailchimp-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">
                <div slot="Algemeen">
                    <accordion-input :open="true">
                        <template #label>

                            <div class="font-medium text-gray-600">Welk formulier?</div>

                        </template>
                        <template #content>
                            
                            <small class="block mb-3 text-gray-600 label text-muted">
                                Kies hier het formulier wat getoond dient te gaan worden.
                            </small>
                            
                            <v-select
                                :options="forms"
                                label="name"
                                v-model="options.form_id"
                                :reduce="form => form.id"
                            >

                                <div slot="no-options">Geen opties</div>

                            </v-select>

                        </template>
                    </accordion-input>

                    <accordion-input :open="!mailchimp_api_key">
                        <template #label>

                            <div class="font-medium text-gray-600">Mailchimp API Key</div>

                        </template>
                        <template #content>
                            
                            <small class="block mb-3 text-gray-600 label text-muted">
                                Account instelling API key
                                <br />Zie ook <a href="https://mailchimp.com/help/about-api-keys/" target="_blank" class="text-blue-600 underline">Mailchimp Api Key</a>.
                                en <a href="https://www.youtube.com/watch?v=ctcy1_npmRE&ab_channel=StrangerStudios" target="_blank" class="text-blue-600 underline">Video over Mailchimp API key</a>.
                            </small>
                            
                            <input
                                ref="mailchimp_api_key"
                                type="text"
                                class="w-full border border-gray-300 rounded-lg"
                                v-model="mailchimp_api_key"
                                v-on:change="saveSettings"
                            >

                        </template>
                    </accordion-input>

                    <accordion-input :open="true">
                        <template #label>

                            <div class="font-medium text-gray-600">Mailchimp List/Audience ID</div>

                        </template>
                        <template #content>
                            
                            <small class="block mb-3 text-gray-600 label text-muted">
                                <br />Dit kan je in Mailchimp (<a href="https://mailchimp.com/help/find-audience-id/" target="_blank" class="text-blue-600 underline">link</a>) vinden onder 'Settings' -> 'Audience name and defaults'.
                            </small>

                            <v-select
                                :options="mailchimp_lists"
                                label="name"
                                v-model="options.mailchimp_list_id"
                                :reduce="list => list.id"
                            >

                                <div slot="no-options">Geen opties</div>

                            </v-select>

                        </template>
                    </accordion-input>

                </div>

                <div slot="Design">
                    <CommonInputs
                        :options="options"
                    />
                </div>
            
            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>
import { inject, provide } from "vue";
import axios from 'axios';
import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        AccordionInput,
        Tabs,
    },

    data() {
        return {
            forms: [],
            mailchimp_lists: [],
            
            mailchimp_api_key: '',
        };
    },

    created() {
        this.loadForms();
    },

    mounted() {
        this.fetchSettings();
    },

    methods: {

        async loadForms() {
            // Load artists.
            this.forms = (await axios.get(this.adminUrlPrefix + '/forms')).data;
        },

        async fetchSettings() {
            try {
                const response = await axios.get(this.adminUrlPrefix + `/mailchimp-settings/${this.canvasBlock.id}`);
                this.mailchimp_api_key = response.data.mailchimp_api_key;
                this.mailchimp_lists = response.data.mailchimp_lists;
            } catch (error) {
                console.error("Error fetching Mailchimp settings", error);
            }
        },

        async saveSettings() {
            try {
                const response = await axios.post(this.adminUrlPrefix + '/mailchimp-settings', {
                    canvasBlockId: this.canvasBlock.id,
                    mailchimp_api_key: this.mailchimp_api_key || '',
                });

                this.mailchimp_lists = response.data.mailchimp_lists;
            } catch (error) {
                console.error("Error saving Mailchimp settings", error);

                this.mailchimp_lists = [];
            }
        },

    },

}

</script>